import { UnstyledRouterLink, Container, Header as StyledHeader, LogoImage } from '../styled'

export default function Header() {
  return (
    <StyledHeader>
      <Container>
        <nav>
          <UnstyledRouterLink to="/">
            <LogoImage
              src="https://edpuzzle.imgix.net/edpuzzle-logos/horizontal-logo.svg"
              alt="Edpuzzle logo"
            />
          </UnstyledRouterLink>
        </nav>
      </Container>
    </StyledHeader>
  )
}
